import { Box, Dialog } from "@mui/material"
import { GridToolbarContainer, useGridApiContext } from "@mui/x-data-grid"
import { useRef, useState } from "react"
import { usePapaParse } from "react-papaparse"
import CtAlertModal from "../../../../Modal/CtAlertModal.jsx"
import { UiCtButton } from "../../../../MuiStyled/LibComponent.jsx"
import { CSV_IMPORT_ERRORS, parseFileFormData } from "../../../import-utils.js"

function EditToolbar(props) {
  const { name, table_schema, isExportEnabled, isImportEnabled, arrayHelpers, handleImportContent } = props

  const apiRef = useGridApiContext()

  // Import data
  const importInputRef = useRef(null)
  const { readString } = usePapaParse()
  const [alertMessage, setAlertMessage] = useState(null)
  const [successMessage, setSuccessMessage] = useState(null)

  const closeAlertDialog = (action) => {
    setAlertMessage(null)
    setSuccessMessage(null)
    // switch (action.type) {
    //   case "CLOSE": {
    //     return
    //   }
    //   case "PROCEED": {
    //     return
    //   }
    //   default: {
    //     return
    //   }
    // }
  }

  const handleInputClicked = (e) => {
    // reset any existing selection
    e.target.value = null
  }

  const handleInputFileSelectedEvent = (e) => {
    const asyncHandler = async (ev) => {
      const selectedFile = ev.target.files[0]
      if (selectedFile) {
        // Parse the field data for the file and update the form
        const parsedFile = await parseFileFormData(selectedFile)
        if (!parsedFile) {
          setAlertMessage(CSV_IMPORT_ERRORS.BAD_FILE)
        } else {
          const csvData = readString(parsedFile.utf8, {
            worker: true,
            // transform: (val) => {
            //   return val.replace(/^"(.*)"$/, "$1").replace(/^'(.*)'$/, "$1")
            // },
            complete: (results) => {
              // Transform to array of objects
              const rowObjects = []
              const rowsOnly = [...results.data]
              const headerRow = rowsOnly.shift()
              for (const aRow of rowsOnly) {
                const thisRow = {}
                let colIdx = 0
                for (const aHeader of headerRow) {
                  thisRow[aHeader] = aRow[colIdx]
                  colIdx += 1
                }
                rowObjects.push(thisRow)
              }

              handleImportContent({
                importContent: rowObjects,
                arrayHelpers,
                postErrorMessage: (msg) => setAlertMessage(msg),
                postSuccessMessage: (msg) => setSuccessMessage(msg),
              })
            },
          })
        }
      }
    }
    asyncHandler(e)
  }

  // Toolbar button handlers
  const handleExportClick = () => {
    apiRef.current.exportDataAsCsv({
      fileName: `${name}_export`,
      utf8WithBom: true,
    })
  }

  const handleImportClick = () => {
    importInputRef.current?.click()
  }

  return (
    <GridToolbarContainer
      className="ctd-csv-toolbar"
      sx={{
        paddingBottom: "10px",
      }}
    >
      {isImportEnabled && (
        <>
          <UiCtButton
            className="ctd-csv-link"
            variant="outlined"
            startIcon={<i className={`fa-solid fa-file-import`}></i>}
            onClick={handleImportClick}
          >
            Import CSV
          </UiCtButton>
          <input multiple={false} ref={importInputRef} type="file" onChange={handleInputFileSelectedEvent} onClick={handleInputClicked} hidden />
        </>
      )}
      {isExportEnabled && (
        <UiCtButton className="ctd-csv-link" variant="outlined" startIcon={<i className={`fa-solid fa-file-export`}></i>} onClick={handleExportClick}>
          Download CSV
        </UiCtButton>
      )}
      <Box sx={{ flexGrow: 1 }} />
      {/* Alert pop-up */}
      <Dialog open={!!alertMessage || !!successMessage} onClose={(event, reason) => closeAlertDialog({ type: "CLOSE" })}>
        <CtAlertModal
          title={alertMessage ? "Whoops. There was a problem." : "Success!"}
          message={alertMessage ?? successMessage}
          actionButtons={[
            {
              text: "Close",
              type: "CLOSE",
              classNames: [],
              clickHandler: () => closeAlertDialog({ type: "CLOSE" }),
            },
          ]}
        />
      </Dialog>
    </GridToolbarContainer>
  )
}

export default EditToolbar
